@if (successGenerico === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img src="/assets/img/success.png" width="70px" alt="">
      <h3 class="subtitulo-alert mt-3 mb-2">Sucesso!</h3>
      <p class="paragrafo m-0">Sua solicitação foi processada com sucesso.</p>
      <button class="botao mt-4" id="btnOk" (click)="fechar()">OK</button>
    </div>
  </div>
}
